<!-- footer -->
<div class="footer">
  <!-- noticeWrap -->
  <hp-notice [urlWownet]="urlWownet"></hp-notice>
  <!-- //noticeWrap -->
  <div class="row container btmInfo">
    <div class="col-xs-12 col-lg-6">
      <div class="btmMenu">
        <ng-container *ngFor="let item of footerMenu;">
          <ng-container *ngIf="item.loginYn == 'A' || (isLogin && item.loginYn == 'Y') || (!isLogin && item.loginYn == 'N')">
            <ng-container *ngIf="item.helpUrl">
              <a [href]="item.helpUrl" target="_blank">{{ item.prgName }}</a>
            </ng-container>
            <ng-container *ngIf="!item.helpUrl && item.linkInfo">
              <a [routerLink]="item.linkInfo">{{ item.prgName }}</a>
            </ng-container>
            <ng-container *ngIf="!item.helpUrl && !item.linkInfo">
              <a (click)="handleAlert();">{{ item.prgName }}</a>
            </ng-container>
          </ng-container>          
        </ng-container>
      </div>
      <div class="compInfo" *ngIf="company$ | async as company">
        <span>{{ company.comName }}</span>
        <span>주소. {{ company.addr1 }}</span>
        <span>전화. {{ company.tel }}</span>
        <span>팩스. {{ company.fax }}</span>
        <span>이메일. {{ company.eMail }}</span>
        <span>대표. {{ company.comOwner }}</span>
        <span>사업자등록번호. {{ company.comTaxNo }}</span>
        <span>통신판매업신고번호. {{ company.secName }}</span>
      </div>
      <div class="btmCopy" *ngIf="company$ | async as company">
        <p>Copyright ⓒ 2023 {{ company.comName }}. All Rights Reserved.</p>
      </div>
    </div>
    <div class="col-xs-12 col-lg-6">
      <div class="snsWrap">
        <a href="#none">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
          <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
          </svg>
        </a>
        <a href="#none">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
          </svg>
        </a>
        <a href="#none">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
            <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>
          </svg>
        </a>
      </div>
      <div class="btmCall">
        <h2>
          고객센터
          <span *ngIf="company$ | async as company">{{ company.tel }}</span>
        </h2>
        <p>운영시간 : 평일 10:00~18:00</p>
      </div>
    </div>
  </div>
</div>
<!-- //footer -->

<div class="quickMenu">
  <ul>
    <!-- <ng-container *ngFor="let item of sidebarMenu;">
      <li>
        <a (click)="handleClick(item.linkInfo)">
          <svg width="30" height="20" viewBox="0 0 53.15 51.02" fill="none">
            <path [attr.d]="item.prgId | getPathSvg: 'solid'"></path>
          </svg>
          <p>{{ item.prgName }}</p>
        </a>
      </li>
    </ng-container> -->


    <li>
      <a [routerLink]="'/shopping-mall/wishlist'">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.18 39.21">
          <!-- <defs>
            <style>.cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-2{fill:#3a3a3a;}</style>
          </defs> -->
          <g id="레이어_2" data-name="레이어 2">
            <g id="image">
              <path class="cls-1" d="M43.93,12.79A11.53,11.53,0,0,0,22.59,6.71,11.54,11.54,0,1,0,4.7,21L22.59,38,40.49,21A11.51,11.51,0,0,0,43.93,12.79Z"/>
              <path class="cls-t" d="M32.72,7.69A1.53,1.53,0,0,0,33,7.63l-.14,0h.4c.34,0-.2-.06,0,0l.57.15.22.08c.2.07-.26-.13.06,0a5.18,5.18,0,0,1,.57.31L35,8.4s.36.29.09.06a9.3,9.3,0,0,1,1,.92l.24.28c-.22-.26,0,.05.07.11s.23.35.34.53l.16.32c0,.06.19.44.06.11.08.22.16.44.22.67a3.38,3.38,0,0,1,.08.34s0,.08,0,.13,0,.05,0-.12c.09.07,0,.59,0,.7s0,.11,0,.17c0-.19,0-.21,0-.07s0,.23-.08.35-.07.23-.11.34,0,.12,0,0a1.3,1.3,0,0,0-.08.17,1.28,1.28,0,0,0,.44,1.71,1.26,1.26,0,0,0,1.71-.45c1.77-3.63-.89-7.79-4.37-9.16a4.25,4.25,0,0,0-2.68-.19,1.25,1.25,0,1,0,.67,2.41Z"/>
            </g>
          </g>
        </svg>
        <p>찜한상품</p>
      </a>
    </li>
    <!-- cart zone -->
    <li>
        <a href="javascript:;" (click)="handleClickToCart();">
            <div class="quickCart">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.15 51.02">
                    <!-- <defs>
                        <style>.cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}</style>
                      </defs> -->
                    <g id="레이어_2" data-name="레이어 2">
                        <g id="image">
                            <polyline class="cls-1" points="48.04 23.55 44.64 49.77 8.52 49.77 5.12 23.55" />
                            <rect class="cls-1" x="1.25" y="15.11" width="50.65" height="7.73" />
                            <line class="cls-1" x1="19.43" y1="1.25" x2="11.97" y2="14.31" />
                            <line class="cls-1" x1="33.72" y1="1.25" x2="41.18" y2="14.31" />
                            <line class="cls-1" x1="17.33" y1="30.04" x2="17.33" y2="41.44" />
                            <line class="cls-1" x1="26.58" y1="30.04" x2="26.58" y2="41.44" />
                            <line class="cls-1" x1="35.83" y1="30.04" x2="35.83" y2="41.44" />
                        </g>
                    </g>
                </svg>
                <ng-container *ngIf="!isLogin">
                    <span>{{ cartLengthNotLogin }}</span>
                </ng-container>
                <ng-container *ngIf="isLogin">
                    <span>{{ cartLength }}</span>
                </ng-container>
            </div>
            <p>장바구니</p>
        </a>
    </li>
    <!-- cart zone -->
    <li>
      <a [routerLink]="'/my-office/order-management/order-details-inquiry'">
        <svg width="59" height="49" viewBox="0 0 59 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3_53)">
          <path class="cls-1" d="M57.8 5.20001C57.8 7.40001 56 9.10001 53.9 9.10001H5.2C3 9.10001 1.2 7.40001 1.2 5.20001C1.2 3.00001 3 1.20001 5.2 1.20001H53.8C56 1.20001 57.8 3.00001 57.8 5.20001Z" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.9 45.1V1.20001H47.1V45.1" fill="white"/>
          <path class="cls-1" d="M11.9 45.1V1.20001H47.1V45.1" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M12.1 45.2L15.6 47.3L19.1 45.2L22.5 47.3L26 45.2L29.5 47.3L33 45.2L36.4 47.3L39.9 45.2L43.4 47.3L46.9 45.2" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M19.6 12.5H39.4" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M19.6 21.5H39.4" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M19.6 30.5H39.4" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
          <clipPath id="clip0_3_53">
          <rect width="59" height="48.5" fill="white"/>
          </clipPath>
          </defs>
        </svg>
        <p>주문/배송</p>
      </a>
    </li>
    <li>
      <a [routerLink]="'/my-office/point/point-inquiry'">
        <svg width="53" height="43" viewBox="0 0 53 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2_27)">
          <path class="cls-1" d="M32.9 7.7C32.9 11.3 27.5 14.1 17.1 14.1C6.7 14.1 1.3 11.2 1.3 7.7C1.3 4.2 6.7 1.3 17.1 1.3C27.5 1.2 32.9 4.1 32.9 7.7Z" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M24.7 19.6C22.3 20 19.8 20.1 17.1 20.1C6.7 20.1 1.3 17.2 1.3 13.7" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M22.8 25.9C21 26.1 19.1 26.2 17.1 26.2C6.7 26.2 1.3 23.3 1.3 19.8" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M22.3 32C20.6 32.2 18.9 32.2 17.1 32.2C6.7 32.2 1.3 29.3 1.3 25.8" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M32.9 13.1V7.29999" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M1.2 27.2V8.10001" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M39.7885 40.7121C47.529 39.4502 52.781 32.1524 51.5191 24.4119C50.2573 16.6714 42.9594 11.4194 35.2189 12.6813C27.4785 13.9431 22.2265 21.2409 23.4883 28.9814C24.7502 36.7219 32.048 41.9739 39.7885 40.7121Z" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-t" d="M33.3 20H38.3C41.6 20 43.2 22 43.2 24.6C43.2 27.2 41.6 29.2 38.3 29.2H35.4V34.2H33.3V20ZM38.1 27.3C40.2 27.3 41 26.1 41 24.5C41 22.9 40.1 21.8 38.1 21.7H35.4V27.2H38.1V27.3Z" fill="#3A3A3A"/>
          <path class="cls-t" d="M13.2 4.39999H18.2C21.5 4.39999 23.1 5.39999 23.1 6.69999C23.2 7.99999 21.6 8.99999 18.3 8.99999H15.4V11.5H13.3V4.39999H13.2ZM18.1 8.09999C20.2 8.09999 21 7.49999 21 6.69999C21 5.89999 20.1 5.29999 18.1 5.29999H15.4V8.09999H18.1Z" fill="#3A3A3A"/>
          </g>
          <defs>
          <clipPath id="clip0_2_27">
          <rect width="52.9" height="42.1" fill="white"/>
          </clipPath>
          </defs>
        </svg>
        <p>포인트조회</p>
      </a>
    </li>
    <li>
      <a [routerLink]="'/my-office/prepay/prepayment-details-inquiry'">
        <svg width="53" height="43" viewBox="0 0 53 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2_40)">
          <path class="cls-1" d="M32.9 7.7C32.9 11.3 27.5 14.1 17.1 14.1C6.7 14.1 1.3 11.2 1.3 7.7C1.3 4.2 6.7 1.3 17.1 1.3C27.5 1.2 32.9 4.1 32.9 7.7Z" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M24.7 19.6C22.3 20 19.8 20.1 17.1 20.1C6.7 20.1 1.3 17.2 1.3 13.7" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M22.8 25.9C21 26.1 19.1 26.2 17.1 26.2C6.7 26.2 1.3 23.3 1.3 19.8" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M22.3 32C20.6 32.2 18.9 32.2 17.1 32.2C6.7 32.2 1.3 29.3 1.3 25.8" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M32.9 13.1V7.29999" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M1.2 27.2V8.10001" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-1" d="M39.7885 40.7121C47.529 39.4502 52.781 32.1524 51.5191 24.4119C50.2573 16.6714 42.9594 11.4194 35.2189 12.6813C27.4785 13.9431 22.2265 21.2409 23.4883 28.9814C24.7502 36.7219 32.048 41.9739 39.7885 40.7121Z" stroke="#3A3A3A" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="cls-t" d="M29.2 21.1H31.2L33.7 30.9H33.8L36.4 21.1H38.4L41 31H41.1L43.6 21.2H45.6L42.1 33.9H40.1L37.4 24.4H37.3L34.6 33.9H32.6L29.2 21.1Z" fill="#3A3A3A"/>
          <path class="cls-t" d="M8.7 4.79999H10.7L13.2 9.69999H13.3L15.9 4.79999H17.9L20.5 9.69999H20.6L23 4.79999H25L21.5 11.2H19.5L16.8 6.39999H16.7L14 11.2H12L8.7 4.79999Z" fill="#3A3A3A"/>
          </g>
          <defs>
          <clipPath id="clip0_2_40">
          <rect width="52.9" height="42.1" fill="white"/>
          </clipPath>
          </defs>
        </svg>
        <p>W페이</p>
      </a>
    </li>
    <li>
      <a [routerLink]="'/my-office/point/point-login'">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.34 44.09">
          <!-- <defs>
            <style>.cls-1{fill:none;}.cls-1,.cls-2{stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-3{fill:#fff;}</style>
          </defs> -->
          <g id="레이어_2" data-name="레이어 2">
            <g id="image">
              <rect class="cls-1" x="1.25" y="5.14" width="45.29" height="37.7" rx="1.05"/>
              <line class="cls-1" x1="45.76" y1="15.87" x2="1.25" y2="15.87"/>
              <line class="cls-1" x1="45.76" y1="29.75" x2="1.25" y2="29.75"/>
              <line class="cls-1" x1="12.64" y1="42.4" x2="12.64" y2="16.48"/>
              <line class="cls-1" x1="23.9" y1="42.4" x2="23.9" y2="16.48"/>
              <line class="cls-1" x1="35.15" y1="42.4" x2="35.15" y2="16.48"/>
              <line class="cls-1" x1="13.16" y1="6.53" x2="13.16" y2="1.25"/>
              <line class="cls-1" x1="19.97" y1="6.53" x2="19.97" y2="1.25"/>
              <line class="cls-1" x1="6.36" y1="6.53" x2="6.36" y2="1.25"/>
              <line class="cls-1" x1="34.11" y1="6.53" x2="34.11" y2="1.25"/>
              <line class="cls-1" x1="40.91" y1="6.53" x2="40.91" y2="1.25"/>
              <line class="cls-1" x1="27.3" y1="6.53" x2="27.3" y2="1.25"/>
              <circle class="cls-1 cls-3" cx="45.59" cy="14.2" r="9.5"/>
              <polyline class="cls-1" points="49.42 12.01 44.19 17.55 41.98 13.97"/>
            </g>
          </g>
        </svg>
        <p>출석체크</p>
      </a>
    </li>
  </ul>
  <div class="recentProd">
    <p>최근 본 상품</p>
    
    <div class="recentSlide">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let item of pdtRecent">
          <ng-container *ngIf="item.fileName === null || item.fileName === ''">
            <a (click)="handleOnClickProductDetail(item);">
              <img src="./assets/img/noImage.jpg" alt="">
            </a>
          </ng-container>
          <ng-container *ngIf="item.fileName !== null && item.fileName !== ''">
            <a (click)="handleOnClickProductDetail(item);">
              <img [src]="urlWownet + item.filePath + item.fileName" alt="">
            </a>
          </ng-container>
          
        </div>
      </div>
      <div class="contWrap">
        <div class="swiper-button-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          </svg>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </div>				
      </div>
    </div>
  </div>
  <a (click)="handleOnClickBackToTop();" class="goTop">
    TOP
  </a>
</div>